import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllPersons } from "../../services/personService";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, CircularProgress, Box, FormControlLabel, Checkbox } from "@mui/material";

export default function PersonList() {
  const navigate = useNavigate();
  const [persons, setPersons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);

  useEffect(() => {
    async function load() {
      try {
        const data = await getAllPersons();
        setPersons(data);
      } catch (err) {
        console.error("Kon personen niet laden:", err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showInactive}
              onChange={(e) => setShowInactive(e.target.checked)}
            />
          }
          label="Toon niet-actieve personen"
        />
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Voornaam</TableCell>
            <TableCell>Achternaam</TableCell>
            <TableCell>Lengte</TableCell>
            <TableCell>Huidig gewicht</TableCell>
            <TableCell>BMI</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {(showInactive ? persons : persons.filter(p => p.status !== "Deleted")).map(p => (
            <TableRow
              key={p.id}
              onClick={() => navigate(`/persons/${p.id}`)}
              sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
            >
              <TableCell>{p.id}</TableCell>
              <TableCell>{p.firstName}</TableCell>
              <TableCell>{p.lastName}</TableCell>
              <TableCell>{p.heightInCentimeters}cm</TableCell>
              <TableCell>{p.currentWeight ?? "-"}kg</TableCell>
              <TableCell>{p.bmi?.toFixed(2) ?? "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}